<script setup lang="ts">
import GridComponent from '~/components/GridComponent.vue'
import { Form } from '~/layers/forms/models'

interface Props {
  identifier?: Form | string
  cols?: number
}

const props = withDefaults(defineProps<Props>(), {
  identifier: undefined,
  cols: 3,
})

const id = computed(() => {
  const identifiers: (Form | string | undefined)[] = Object.values(Form)
  if (identifiers.includes(props.identifier)) {
    return `${props.identifier}-form`
  }

  return props.identifier
})
</script>

<template>
  <div
    :id
    class="bg-light p-4 rounded-lg border"
  >
    <GridComponent
      :id
      v-slot="{ classGetter }"
      :cols
      :min-cols="1"
    >
      <slot :section-classes="classGetter" />
    </GridComponent>
  </div>
</template>
